import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { StoreName } from '../../../shared/stores/StoreName';
import { Utils } from '@logio/common-be-fe';
import { T } from '../../i18n/T';
import Alert, { AlertType } from '../../info/Alert';
import translate from '../../i18n/translate';
import { CONSTANTS } from '../../../constants';
import { withPermission } from "../../../shared/security/withPermission";
/**
 *  Check if user is authorized to access the page
 */

var PrivilegesControl =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PrivilegesControl, _React$Component);

  function PrivilegesControl() {
    _classCallCheck(this, PrivilegesControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PrivilegesControl).apply(this, arguments));
  }

  _createClass(PrivilegesControl, [{
    key: "render",
    value: function render() {
      if (!Utils.isValueMissing(CONSTANTS.KEYCLOAK.CONFIG.bearer) || !this.props.privileges || this.props.privileges.length === 0 || withPermission(this.props.privileges, true)) {
        return this.props.children;
      }

      if (this.props.hideError) {
        return React.createElement(React.Fragment, null);
      }

      return React.createElement("main", null, React.createElement(Alert, {
        type: AlertType.Error,
        title: translate("Error"),
        className: "rounded"
      }, React.createElement("div", {
        className: "fs-150 mb2"
      }, React.createElement(T, {
        id: "err-not-enough-privileges"
      })), React.createElement("div", {
        className: "fs-130 mb1"
      }, React.createElement(T, {
        id: "err-not-enough-privileges-detail"
      })), React.createElement("div", {
        className: "mb1"
      }, this.props.privileges.map(function (privilege, index) {
        return React.createElement("li", {
          key: index,
          className: "bold"
        }, privilege.name);
      })), React.createElement("div", {
        className: "fs-130"
      }, React.createElement(T, {
        id: "err-not-enough-privileges-admin"
      }))));
    }
  }]);

  return PrivilegesControl;
}(React.Component);

PrivilegesControl = __decorate([inject(function (allStores) {
  return {
    profileStore: allStores[StoreName.Profile]
  };
}), observer], PrivilegesControl);
export default PrivilegesControl;